import React from "react";
import { Button, Stack } from "@mui/material";
import styled from "styled-components";
import { Link as RouteLink } from "react-router-dom";
import googleWorkspace from "src/assets/icons/google-workspace";
import github from "src/assets/icons/github";
import jira from "src/assets/icons/jira";
import Icon from "../../components/icon";
import gitlab from "../../assets/icons/gitlab";
import slack from "../../assets/icons/slack";
import microsoft from "../../assets/icons/microsoft";

const H2 = styled.h2`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.error.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    width: 100%;
`;

const NameMap = {
    work: {
        svgs: [gitlab, github, jira],
        title: "I will not work for Slackers!",
        subtitle: "Please integrate with your git or Jira account to start viewing work data",
    },
    collaboration: {
        svgs: [slack, googleWorkspace, microsoft],
        title: "Come on slack a little more!",
        subtitle:
            "Please integrate with your slack, google or microsoft account to start viewing collaboration data",
    },
};

const NotIntegrated = ({ name }) => {
    const dataMap = NameMap[name];
    if (!dataMap) return null;

    return (
        <BorderedStack
            spacing={7}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            <Stack direction="row" alignItems="center">
                {dataMap.svgs.map((svg) => (
                    <Icon svg={svg} width="160px" height="auto" style={{ padding: "24px" }} />
                ))}
            </Stack>
            <Stack alignItems="center">
                <H2>{dataMap.title}</H2>
                <Span>{dataMap.subtitle}</Span>
            </Stack>
            <Button
                variant="contained"
                component={RouteLink}
                to="/integrations"
                data-testid="dashboard-link"
            >
                Integrations
            </Button>
        </BorderedStack>
    );
};

export default NotIntegrated;
